import { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation, useOutlet } from 'react-router-dom'

import { Card, Footer, MerchantHeader } from '@reveni-io/reveni-ui'

import AppContext from '@/context/AppContext'
import { getMerchantHeaderDescriptionText } from '@/helpers'
import useCancellationsPortal from '@/hooks/useCancellationsPortal/useCancellationsPortal'
import useProcessSteps from '@/hooks/useProcessSteps/useProcessSteps'

import StepperProcess from '../StepperProcess/StepperProcess'
import AnimatedContent from './AnimatedContent/AnimatedContent'
import useNavigationDirection from './hooks/useNavigationDirection/useNavigationDirection'
import { getCardPropsByPathName } from './helpers'
import * as Styles from './styles'

const PageLayout = () => {
  const { context } = useContext(AppContext)
  const location = useLocation()
  const outlet = useOutlet()
  const { t } = useTranslation()
  useProcessSteps()
  const { activeStep, backLink, cardTitle } = getCardPropsByPathName({
    location,
    orderInfo: context.orderInfo,
    merchantInfo: context.merchantInfo,
    orderRecovery: context.orderRecovery,
  })
  const { portalType } = useCancellationsPortal()
  const { direction } = useNavigationDirection({ routes: context?.processSteps, currentRoute: location.pathname })

  return (
    <Styles.Layout
      background={context.merchantInfo?.theme?.returns_background_url}
      backgroundMobile={context.merchantInfo?.theme?.returns_background_mobile_url}
      location={location.pathname}
    >
      <Styles.MerchantHeaderContainer>
        <MerchantHeader
          logoUrl={context?.merchantInfo?.theme?.logo_url}
          storeName={context?.merchantInfo?.name}
          storeUrl={context?.merchantInfo?.domain}
          descriptionText={t(
            getMerchantHeaderDescriptionText(
              context?.merchantInfo?.preferences?.transaction_types,
              portalType,
              context?.orderInfo?.is_gift_return
            )
          )}
          orderNumber={`${t('Pedido')} ${context?.orderInfo?.name}`}
        />
      </Styles.MerchantHeaderContainer>
      <Card
        header={activeStep !== null && <StepperProcess activeStep={activeStep} steps={context?.processSteps} />}
        title={t(cardTitle, { orderInfo: context?.orderInfo })}
        backLink={backLink}
        footer={
          <Footer
            partnerLogo={context?.merchantInfo?.theme?.partner_logo_url}
            partnerUrl={context?.merchantInfo?.theme?.partner_url}
          />
        }
      >
        <AnimatedContent direction={direction} currentRoute={location.pathname}>
          {outlet}
        </AnimatedContent>
      </Card>
    </Styles.Layout>
  )
}

export default PageLayout
